import React, { Component } from "react";
import { Link } from 'react-router-dom';

class Purpose extends Component {
  render() {
    return (

      <div>
        <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">รู้จักสหกรณ์</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="purpose" className="a-breadcrumbs">วัตถุประสงค์</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50 Infomation-Font" style={{fontFamily: '"Cordia New"'}}>
                <h2 className="title-section mt-0 mb-0"><span>วัตถุประสงค์</span></h2><br/>
                <div className="divider gray left mt-20 mb-25" />
                <p className="mb-20">สหกรณ์ออมทรัพย์ไทยออยล์ จำกัด จัดตั้งและได้รับการจดทะเบียนจากนายทะเบียนสหกรณ์ให้ดำเนินกิจการเมื่อวันที่ 7 ตุลาคม 2529 ภายใต้ พ.ร.บ.สหกรณ์ พ.ศ.2511 โดยมีวัตถุประสงค์เพื่อส่งเสริมฐานะทางเศรษฐกิจและสังคมของสมาชิกด้วยวิธีร่วมดำเนินธุรกิจการ เงินเพื่อประโยชน์ด้วยกัน ได้แก่</p>
                <ul className="mb-25">
                  <li>(1) ส่งเสริมการออมทรัพย์ของสมาชิก</li>
                  <li>(2) ส่งเสริมการช่วยเหลือตนเอง และการช่วยเหลือซึ่งกันและกันในหมู่สมาชิก</li>
                  <li>(3) รับฝากเงินจากสมาชิก หรือสหกรณ์อื่น</li>
                  <li>(4) ให้บริการเงินกู้ยืมแก่สมาชิกตามความจำเป็นหรือมีประโยชน์</li>
                  <li>(5) ดำเนินการให้กู้ยืมเพื่อการเคหะ</li>
                  <li>(6) ให้สหกรณ์อื่นกู้ยืมเงิน</li>
                  <li>(7) จัดสวัสดิการให้แก่สมาชิกและครอบครัว</li>
                  <li>(8) จัดให้ได้มา ซื้อ ถือกรรมสิทธิ์ หรือทรัพย์สินครอบครองกู้ หรือยืม เช่า เช่าซื้อ รับโอนสิทธิการเช่า หรือสิทธิการเช่าซื้อ จำนอง หรือจำนำ ขายหรือจำหน่ายด้วยวิธีอื่นใดซึ่งทรัพย์สิน</li>
                  <li>(9) ให้เช่า ให้เช่าซื้อ ให้สินเชื่อ โอน รับจำนอง หรือรับจำนำซึ่งทรัพย์สินแก่สมาชิก หรือของสมาชิก</li>
                  <li>(10) ให้ความช่วยเหลือทางวิชาการแก่สมาชิกและกรรมการ</li>
                  <li>(11) ให้การสงเคราะห์ตามสมควรแก่สมาชิก และครอบครัวที่ต้องภัยพิบัติ</li>
                  <li>(12) ให้ความร่วมมือกับทางราชการ สันนิบาตสหกรณ์แห่งประเทศไทย ชุมนุมสหกรณ์และสหกรณ์อื่น เพื่อส่งเสริมกิจการ สหกรณ์</li>
                  <li>(13) กระทำการต่างๆ ตามที่กฎหมายว่าด้วยสหกรณ์ให้กระทำได้ เพื่อให้เป็นไปตามวัตถุประสงค์ของสหกรณ์</li>
                </ul>
                <br/>
                <br/>
              </div>
            </div>
          </div>
        </section>
      </div>

);
  }
}

export default Purpose;
